import { useEffect } from "react";

// The production homepage is the prerendered static landing at `/`.
// When the SPA route is hit (e.g. logo click from /signup), hard-navigate
// to the static document instead of iframe-loading /landing-home/index.html,
// which is removed from dist after prerender and would fall through to app.html.
//
// In dev there is no prerender step, so `/` is the SPA shell itself and this
// component owns that route - replacing to `/` would re-mount it and hard-
// reload in an infinite loop. The static marketing page is served straight
// from `public/landing-home/` in dev, so point there instead.
export function LandingPage() {
  useEffect(() => {
    window.location.replace(import.meta.env.PROD ? "/" : "/landing-home/index.html");
  }, []);

  return null;
}
